import styled from 'styled-components';
import { Flex, fontSize } from '@landr/maestro';

const DownloadMenuItemContainer = styled(Flex)`
    align-items: center;
    justify-content: space-between;
    line-height: ${fontSize('xl')};
    width: 100%;
`;

export const Styled = {
    DownloadMenuItemContainer,
};
